/**
 * 接口请求的封装
 */

import axios from 'axios';
import env from '@/api/env';
import notLoad from '@/api/notLoad';
import {Message, Loading} from 'element-ui';
import store from '@/store/store';
import router from '@/router/router';
import {removeToken} from '@/utils/auth';

const ENV = process.env.NODE_ENV === 'production' ? env.PROD_ENV : env.PROD_ENV;

let loadingInstance;
const service = axios.create({
    baseURL: ENV,
    origin: ENV,
    headers: {"Content-Type": "application/json;charset=utf-8"}
});

function toQuery(obj) {
    const arr = []
    for (const k in obj) {
      if (['object', 'array'].includes(typeof obj[k])) {
        obj[k] = JSON.stringify(obj[k])
      }
      arr.push(`${k}=${encodeURIComponent(obj[k])}`)
    }
    return arr.join('&')
  }

// 公共请求接口
service.interceptors.request.use(config => {
    let notLoadParams = config.data.servername + '::' + config.data.method;

    if(notLoadParams === "Ruyi_basic_services::get_version_info")
    {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.baseURL = env.PROD_FRONT_ENV;
        config.data.servicename = config.data.servername;
        delete config.data.servername
        config.data = toQuery(config.data)
    } else {
        // 每次请求token绑在data上
        config.data['token'] = store.getters.token ? store.getters.token : null;
        if (notLoad.notLoadIcon.indexOf(notLoadParams) == -1) {
            loadingInstance = Loading.service({fullscreen: true})
        }
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// 接口返回
service.interceptors.response.use(response => {
    if (response.data.code == 1005) {
        removeToken();
        store.commit('REMOVE_TOKEN');
        router.replace('/login');
    }

    // if (response.data.code == 1007) {
    //     Message({
    //         type: 'error',
    //         message: response.data.msg,
    //         duration: 3000
    //     });
    // }

    if (loadingInstance) {
        loadingInstance.close();
    }

    return response;
}, error => {
    return Promise.reject(error);
});

export default service;